import { useMutation, useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FileMinus } from "react-feather";
import FilterBar from "../../Components/UI/filterbar";
import DataTable from "../../Components/UI/table/DataTable";
import TableActions from "../../Components/UI/table/TableActions";
import StatusStore from "../../Components/UI/statusStore";
import { deleteStores, getStores, updateStore, importExcelStores, exportExcelStores } from "../../MyApi/stores";
import SingleStar from "../Common/svg/singleStar";
import i18next from "i18next";
import StatusBadge from "../UI/statusBadge";
import { useRef, useState } from "react";
import { postBulkDelete } from "../../MyApi/bulkdelete";

const StoresTab = ({ currentPage, setCurrentPage, filters, setFilters }) => {
  const location = useLocation();
  const navigate = useNavigate();
 const [selectedStoresIds, setSelectedStoresIds] = useState([]);
    const fileInputRef = useRef(null);
  const lang =i18next.language;
  const {
    data: storesData,
    isLoading: storesLoading,    
    isFetching: storesFetching,
    refetch: storesRefetch,
    error: storesError,
  } = useQuery(
    ["stores", currentPage, filters],
    () => {
      return getStores(currentPage, filters);
    },
    {
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000,
    }
  );
console.log('currentPage', currentPage)
  const activeStatusMutation = useMutation({
    mutationKey: ["activeStore"],
    mutationFn: ({ id, formData }) => updateStore(formData, id),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      storesRefetch();
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });
  const mutateBulkDelete = useMutation({
    mutationKey: ["bulkDeleteStores"],
    mutationFn: (ids) => postBulkDelete(ids),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      setSelectedStoresIds([]);
      storesRefetch();
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "حدث خطأ أثناء الحذف");
    },
  });

  const importMutation = useMutation({
    mutationKey: ["importStores"],
    mutationFn: importExcelStores,
    onSuccess: () => {
      toast.success("تم استيراد الملف بنجاح");
    },
    onError: () => {
      toast.error("حدث خطأ أثناء الاستيراد");
    },
  });

  const { mutate: importStores, isLoading: isImporting } = importMutation;

  const handleExport = async () => {
    try {
      const res = await exportExcelStores({});

      if (res.success === true) {
        toast.success(`${res.message}`);
         navigate(`${process.env.PUBLIC_URL}/downloads`);
      }else{
        toast.error("حدث خطأ أثناء التصدير");
      }
 
    } catch (error) {
      console.error(error);
    }
  };




    const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    importStores(file);
    e.target.value = null;
  };

  const handleStoreActive = (id, is_active) => {
    const formData = new FormData();
    formData.append("_method", "PUT");
    formData.append("store[is_active]", is_active ? 0 : 1);
    activeStatusMutation.mutate({ id, formData });
  };

  const listData = storesData?.data?.Stores || [];
  const totalItems = storesData?.data?.pagination?.total || 0;
  const lastPage = storesData?.data?.pagination?.last_page || 0;


    const handleBulkChecked = (e, id) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedStoresIds((prev) => [...prev, id]);
    } else {
      setSelectedStoresIds((prev) => prev.filter((productId) => productId !== id));
    }
  };

  const deleteSelectedStores = () => {
    if (selectedStoresIds.length === 0) {
      toast.error("يرجي اختيار متاجر لحذفها");
      return;
    }
    mutateBulkDelete.mutate({ ids: selectedStoresIds, type: "store" });
  };

  const storeColumns = [
    {label:  "تحديد عناصر" ,render:  (row) => <input  type="checkbox" checked={selectedStoresIds.includes(row.id)} onChange={(e)=>handleBulkChecked(e , row.id)}/>} , 
    {
      label: "معرف المتجر",
      render: (row) => <div className="text-green"> #{row.id}</div>,
    },
    { label: "اسم المتجر", accessor: "name" },
    { label: "مالك المتجر", render: (row) => <div>{row.owner_name.length > 0 ? row.owner_name : "___"}</div> },
    { label: "القسم", accessor: "section_name" },    
    { label: "رقم الجوال", accessor: "phone" },
    { label: "عدد الفروع", accessor: "count_branches" },
    {label :"نوع المتجر" , accessor:"section_type"},
    { label: "عدد الطلبات", accessor: "count_orders" },
    {
      label: "التقييم",
      render: (row) => <div className="d-flex gap-1 align-items-center"> <span><SingleStar /> </span> <span className="desc"> {row.avg_rate ?? 0}</span> </div> ,
    },
    {
      label: "الحالة",
      render: (row) => <StatusStore status={row.active_status} />,
    },  
        {
      label: "نشط",
      render: (row) => <StatusBadge status={row.is_active ?"active":""} />,  
    },   
    {
      label: "آخر تحديث",
      render: (row) => new Date(row.updated_at).toLocaleDateString("ar-EG"),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
 show={() =>
  navigate(`${process.env.PUBLIC_URL}/store/${row.id}`, {
    state: {
      from: location.pathname + location.search,
      tab: "stores",
         page:currentPage
    },
  })
}
edit={() =>
  navigate(`${process.env.PUBLIC_URL}/stores/edit/${row.id}`, {
    state: {
      from: location.pathname + location.search,
      tab: "stores",
      page:currentPage
    },
  })
}
          refetch={storesRefetch}
          queryKey={"stores"}
          id={row.id}
          
          deleteFn={deleteStores}
          mutationKey={["deleteStores"]}
          activeStatus={() => handleStoreActive(row.id, row.is_active)}
          is_active={row.is_active}
          isLoading={activeStatusMutation.isLoading}
          deletePermission={"delete_store"}
          viewPermission={"view_store"}
          editPermission={"update_store"}
          togglePermission={"update_store"}
          toggleMutationKey={"toggleStoreActive"}
          toggleFn={(id, status)=>updateStore({ store:{ is_active: status}, _method: "PUT" ,lang} ,id)}     
        />
      ),
    },
  ];

  const filtersConfig = { search: "search", is_active: "is_active", date: "date" };

 

  return (
    <>
      <FilterBar
        setFilters={setFilters}
        filters={filters}
        filtersConfig={filtersConfig} 
        placeholder="ابحث باسم المتجر"
      />
      <DataTable
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalItems={totalItems}
        itemsPerPage={lastPage}
        onAddClick={() => navigate("/stores/store", { 
          state: { 
            from: location.pathname + location.search,
            tab: "stores" ,
            page:currentPage
          } 
        })}
        columns={storeColumns}
        data={listData}
        title="المتاجر"
        actionLabel="إضافة المتجر"
        isLoading={storesLoading}
        isFetching={storesFetching}
        createPermission="create_store"
        error={storesError}
        onRetry={() => storesRefetch()}
        excel={true}
        importExcel={handleButtonClick}
        exportExcel={handleExport}
        handleFileChange={handleFileChange}
        fileInputRef={fileInputRef}
        deleteSelectedProducts={deleteSelectedStores}
        isPending={isImporting}
        isBulkDelete={true}
      />
    </>
  );
};

export default StoresTab;
